export default __webpack_public_path__ + "static/media/CNo.71-5.99a1e87a.jpg";